module.exports = __webpack_public_path__ + "img/sign-in-alt.4e13ba6a.svg";